<template>
  <application-layout>
    <v-main>
      <v-form>
        <v-container>
          <h1>Editing {{ firstName }} {{ lastName }}</h1>
          <v-row>
            <v-col cols="12" sm="6">
              <app-input
                data-testid="user-edit-username-input"
                class="user-edit-username-input"
                :type="'text'"
                label="Username"
                :value="username"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <app-input
                data-testid="user-edit-email-input"
                class="user-edit-email-input"
                :type="'email'"
                label="Email"
                :value="email"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="6">
              <app-input
                data-testid="user-edit-first-name-input"
                class="user-edit-first-name-input"
                :type="'text'"
                label="First Name"
                v-model.trim="firstName"
                :rules="'required'"
                :useValidation="true"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <app-input
                data-testid="user-edit-last-name-input"
                class="user-edit-last-name-input"
                :type="'text'"
                label="Last Name"
                v-model.trim="lastName"
                :rules="'required'"
                :useValidation="true"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                data-testid="user-edit-roles-select"
                class="user-edit-roles-select"
                filled
                v-model="userRoles"
                :items="assignableRoles"
                label="User Roles"
                item-text="name"
                item-value="id"
                hint="Roles determine what a user is able to do in the admin"
                persistent-hint
                chips
                multiple
                clearable
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                data-testid="user-edit-cancel-btn"
                class="user-edit-cancel-btn mr-3 ml-0"
                @click="() => { this.$router.back(); }"
                color="error"
              >
                Cancel
              </v-btn>
              <v-btn
                data-testid="user-edit-save-btn"
                class="user-edit-save-btn"
                color="primary"
                @click="updateUser"
                :loading="loading"
                :disabled="!validFields"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";

export default {
  data() {
    return {
      loading: false
    };
  },

  computed: {
    firstName: {
      get() {
        return this.$store.state.user.editUser.first_name;
      },
      set(newValue) {
        this.$store.commit("updateEditUser", {
          property: "first_name",
          value: newValue
        });
      }
    },
    lastName: {
      get() {
        return this.$store.state.user.editUser.last_name;
      },
      set(newValue) {
        this.$store.commit("updateEditUser", {
          property: "last_name",
          value: newValue
        });
      }
    },
    email() {
      return this.$store.state.user.editUser.email;
    },
    username() {
      return this.$store.state.user.editUser.username;
    },
    userRoles: {
      get() {
        return this.$store.state.user.editUser.assigned_roles;
      },
      set(newValue) {
        this.$store.commit("updateEditUser", {
          property: "assigned_roles",
          value: newValue
        });
      }
    },
    assignableRoles() {
      return this.$store.state.role.roles;
    },
    validFields() {
      return !!(this.firstName && this.lastName && this.userRoles.length);
    }
  },

  components: {
    ApplicationLayout
  },

  created() {
    this.$store.dispatch("getUser", this.$route.params.userId);
    this.$store.dispatch("getAssignableRoles");
  },

  methods: {
    async updateUser() {
      this.loading = true;
      await this.$store.dispatch("updateUser")
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
